module.exports = __webpack_public_path__ + "img/icon_other.121ccc10.png";